import React, {useState} from 'react'
import DataTable from 'react-data-table-component';


import ColumnVisibilityManager from './DataTableComponents/ColumnVisibilityManager';
import ExportComponent, { downloadCSV } from './DataTableComponents/ExportComponent';
import { prepareData } from './DataTableComponents/DataUtils';


const GlassTimeTable = ({ columns, posts }) => {

  // Column visibility management
  const startColumnsHidden = []

  const [hiddenColumns, setHiddenColumns] = useState(startColumnsHidden);

  const toggleColumnVisibility = (columnName) => {
    if (hiddenColumns.includes(columnName)) {
      setHiddenColumns(hiddenColumns.filter((col) => col !== columnName));
    } else {
      setHiddenColumns([...hiddenColumns, columnName]);
    }
  };

  // Prepare data
  const { columnManipulation, rawManipulation } = React.useMemo(
    () => prepareData(posts, columns, hiddenColumns),
    [posts, columns, hiddenColumns]
  );

  console.log()


  // Custom table style
  const customStyles = {
      headCells: {
      style: {
          fontWeight: 'bold',
      },
      }   
  };

  // Return table structure
  return (
    <>
      <ColumnVisibilityManager
        columns={columnManipulation}
        hiddenColumns={hiddenColumns}
        toggleColumnVisibility={toggleColumnVisibility}
      />
    
      <DataTable
          columns = {columnManipulation.filter((col) => !col.omit)}
          data = {rawManipulation}
          pagination
          actions={<ExportComponent onExport={() => downloadCSV(rawManipulation)} />}
          subHeader
          persistTableHead
          className='disable-sticky mt-3'
          customStyles={customStyles}
          dense 
      />



    </>
  )
}

export default GlassTimeTable